module.exports = __webpack_public_path__ + "static/media/tile-dark.7ce543e0.webp";